import { URLS, $subscriber } from "fire-wind-water";
import { sdeModel } from "./sde";
import { userModel } from "./user";
import { $messageLoad } from "@/../stempcore/src/core/sextra.js";

const seminarMixin = {
  data() {
    return {
      schemaId: "",
      instanceId: "",
      tenantId: "",
      markCode: "",
      seminarInfo: null,
      globalUserId: "",
      signUpStatus: 0,
      topicTemplateInfo: { agendas: [] },
      extras: null,
      isFrozen: false,
      orderList: [],
      memberInfo: {
        email: "",
        name: "",
        headImg: "",
        signUpStatus: "",
      },
    };
  },
  created() {
    if (URLS.getURL("isSetting") != "1") {
      window.$sk.loading.show();
    }
    window.$sk.template.module(this);
    sdeModel.seminar.module(this);
    userModel.user.module(this);
    $subscriber.subscribe("reload-userInfo", () => {
      userModel.user.getCanRegister(this.seminarInfo);
    });
  },
  mounted() {
    $messageLoad(1);
  },
  methods: {
    skSeminarEnd(res) {
      this.seminarInfo = res;
      document.title = this.seminarInfo.title;
    },
    skSeminarUserEnd(res) {
      this.memberInfo = res;
      this.markCode = res.markCode;
      this.isFrozen = res.isFrozen;
    },
    skExtrasChange(res) {
      this.extras = res;
      this.doOrder();
      window.$sk.loading.hide();
    },
    doOrder() {
      this.orderList = [];
      for (let i in this.extras) {
        if (i.indexOf("Order") > -1) {
          this.orderList.push({ name: i, index: this.extras[i]["order"] });
        }
      }
      this.orderList = this.orderList.sort((x, y) => {
        if (parseFloat(x.index) < parseFloat(y.index)) {
          return -1;
        } else if (parseInt(x.index) > parseInt(y.index)) {
          return 1;
        } else {
          return 0;
        }
      });
      console.log(this.orderList);
    },
    skUserEnd() {
      let instanceId = URLS.getURL("instanceId");
      const info = window.$sk.template.get();
      this.schemaId = info.common.schemaId;
      this.instanceId = instanceId;
      this.tenantId = info.common.tenantId;
      this.globalUserId = info.user.globalUserId;
    },
  },
};
export default seminarMixin;
